import { Component, OnInit, Input } from '@angular/core';
import { UrlService } from 'app/services/url.service';

@Component({
    selector: 'filters-view',
    templateUrl: './filters-view.component.html',
    styleUrls: ['./filters-view.component.scss']
})
export class FiltersViewComponent implements OnInit {
    @Input('itemData') itemData: any;
    @Input('incidentReports') incidentReports: any[] = [];
    parameters: any;
    labelsList: any[] = [];
    constructor(private urlService: UrlService) {
    }

    ngOnInit() {
        this.urlService.getQueryParams();
        this.urlService.onUrlChange.subscribe(params => {
            this.parameters = {};
            this.labelsList = [];
            this.parameters = { ...params };
            if (this.parameters.status) {
                const statuses = [...this.parameters.status.split(',')];
                statuses.forEach(_ => {
                    if (_ === 'did_not_follow_link') {
                        this.labelsList.push('Invited');
                    } else if (_ === 'inactive') {
                        this.labelsList.push('Not invited');
                    } else if (_ === 'active') {
                        this.labelsList.push('Active');
                    } else if (_ === 'in_progress') {
                        this.labelsList.push('in progress');
                    } else if (_ === 'on_hold') {
                        this.labelsList.push('on hold');
                    } else if (_ === 'picked_up') {
                        this.labelsList.push('picked up');
                    } else if (_ === 'signet_out') {
                        this.labelsList.push('signed out');
                    } else {
                        this.labelsList.push(_);
                    }
                });
            }

            if (this.parameters.inOut)
                this.labelsList.push(this.parameters.inOut);

            if (this.parameters.is_public) {
                const isPublic = [...this.parameters.is_public.split(',')];
                isPublic.forEach(_ => {
                    if (_ === '1') {
                        this.labelsList.push('Public');
                    } else if (_ === '0') {
                        this.labelsList.push('Not Public');
                    }
                });
            }

            if (this.parameters.permissions) {
                const permissions = [...this.parameters.permissions.split(',')];
                permissions.forEach(_ => {
                    if (_ === 'owner_on') {
                        this.labelsList.push('owner on-site');
                    } else if (_ === 'rent') {
                        this.labelsList.push('tenant');
                    } else if (_ === 'owner_all') {
                        this.labelsList.push('owner all');
                    } else if (_ === 'owner_off') {
                        this.labelsList.push('owner off-site');
                    } else if (_ === 'resident_owner') {
                        this.labelsList.push('resident owner');
                    } else if (_ === 'resident_only_not_on_deed') {
                        this.labelsList.push('resident only not on deed');
                    } else if (_ === 'owner_family') {
                        this.labelsList.push('owner family');
                    } else if (_ === 'offsite_resident') {
                        this.labelsList.push('offsite resident');
                    } else if (_ === 'not_set') {
                        this.labelsList.push('not set');
                    } else {
                        this.labelsList.push(_);
                    }
                });
            }

            if (this.parameters.role) {
                const permissions = this.parameters.role;

                if (permissions.indexOf('owner_on') != -1)
                    this.labelsList.push('owner on-site');

                if (permissions.indexOf('owner_off') != -1)
                    this.labelsList.push('owner off-site');

                if (permissions.indexOf('unknown') != -1)
                    this.labelsList.push('not set');

                if (permissions.indexOf('rent') != -1)
                    this.labelsList.push('tenant');

                if (permissions.indexOf('resident') != -1)
                    this.labelsList.push('resident');

                if (permissions.indexOf('resident_owner') != -1)
                    this.labelsList.push('resident owner');

                if (permissions.indexOf('resident_only_not_on_deed') != -1)
                    this.labelsList.push('resident only not on deed');

                if (permissions.indexOf('owner_family') != -1)
                    this.labelsList.push('owner family');

                if (permissions.indexOf('guest') != -1)
                    this.labelsList.push('guest');

                if (permissions.indexOf('offsite_resident') != -1)
                    this.labelsList.push('offsite resident');

                if (permissions.indexOf('occupant') != -1)
                    this.labelsList.push('occupant');
            }

            if (this.parameters.category) {
                const category = typeof this.parameters.category == 'string' ? [...this.parameters.category.split(',')] : this.parameters.category;
                category.forEach(c => this.labelsList.push(c));
            }

            if (this.parameters.show_moved_out)
                this.labelsList.push('Archived');

            if (this.parameters.amenity_id) {
                this.itemData.forEach((item, index) => {
                    if (item.checked) this.labelsList.push(item.name);
                    else this.labelsList.splice(index, 1);
                });
            }

            if (this.parameters.readStatus) {
                const statuses = [...this.parameters.readStatus.split(',')];
                statuses.forEach(_ => {
                    if (_ === 'unread') {
                        this.labelsList.push('unread');
                    } else if (_ === 'read') {
                        this.labelsList.push('read');
                    } else {
                        this.labelsList.push(_);
                    }
                });
            }

            if (this.parameters.report_type) {
                if (this.parameters.report_type.length > 1) {
                    this.incidentReports.forEach(element => {
                        this.parameters.report_type.forEach(reportType => {
                            if (element.id === reportType) {
                                this.labelsList.push(element.name);
                            }
                        });
                    });
                } else {
                    this.incidentReports.forEach(element => {
                        if (element.id === this.parameters.report_type) {
                            this.labelsList.push(element.name);
                        }
                    });
                }
            }

            if (this.parameters.user_type) {
                const userTypes = [...this.parameters.user_type.split(',')];
                userTypes.forEach(_ => {
                    if (_ === 'super_admin') {
                        this.labelsList.push('Admin');
                    } else if (_ === 'property_manager') {
                        this.labelsList.push('Staff');
                    } else if (_ === 'resident') {
                        this.labelsList.push('Resident');
                    }
                });
            }

            if (this.parameters.priority)
                this.labelsList.push(...this.parameters.priority.split(','));

            if (this.parameters.type) {
                const userTypes = [...this.parameters.type.split(',')];
                userTypes.forEach(_ => {
                    if (_ === 'range') {
                        this.labelsList.push('time range');
                    } else {
                        this.labelsList.push(_);
                    }
                });
            }

            if (this.parameters.enable_status) {
                const enableStatus = [...this.parameters.enable_status.split(',')];
                enableStatus.forEach(_ => {
                    if (_ === '1') {
                        this.labelsList.push('Active');
                    } else if (_ === '0') {
                        this.labelsList.push('Inactive');
                    }
                });
            }

            if (this.parameters.periodStartDate)
                this.labelsList.push(this.parameters.periodStartDate);

            if (this.parameters.periodEndDate)
                this.labelsList.push(this.parameters.periodEndDate);

            if (this.parameters.createdAt) {
                if(this.parameters.createdAt.indexOf('>') != -1)
                    this.labelsList.push(this.parameters.createdAt.split('>')[1]);
                if(this.parameters.createdAt.indexOf('<') != -1)
                    this.labelsList.push(this.parameters.createdAt.split('<')[0]);
            }

            if(this.parameters.hasPayout)
               this.labelsList.push(this.parameters.hasPayout == '1' ? 'PayOuted' : 'Not PayOuted');

            this.labelsList = this.labelsList.map(label => (label.charAt(0).toUpperCase() + label.slice(1)));
        });

    }

    clearFilters() {
        this.labelsList = [];
        this.urlService.queryParams.status = '';
        this.urlService.queryParams.inOut = '';
        this.urlService.queryParams.permissions = '';
        this.urlService.queryParams.is_public = '';
        this.urlService.queryParams.amenity_id = '';
        this.urlService.queryParams.readStatus = '';
        this.urlService.queryParams.report_type = '';
        this.urlService.queryParams.user_type = '';
        this.urlService.queryParams.priority = '';
        this.urlService.queryParams.type = '';
        this.urlService.queryParams.enable_status = '';
        this.urlService.queryParams.periodStartDate = '';
        this.urlService.queryParams.periodEndDate = '';
        this.urlService.queryParams.createdAt = '';
        this.urlService.queryParams.company_id = '';
        this.urlService.queryParams.category = null;
        this.urlService.queryParams.role = null;
        this.urlService.queryParams.show_moved_out = null;
        this.urlService.queryParams.hasPayout = null;
        this.urlService.setQueryParams();
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/filters-view/filters-view.component.ts